import React, { useState } from 'react';
import { SettingsTutorialSinglePage } from '../SettingsTutorial';

export default function MenuInfo(props) {
    const [toggled, setToggled] = useState(false);

    const toggle = () => setToggled(!toggled);

    return (
        <>
            {toggled ?
                <SettingsTutorialSinglePage index={props.index} toggle={toggle} />
                :
                <div className="w-[24px] h-[24px] flex items-center justify-center border border-cs7 rounded-full" onClick={toggle}>
                    <i className="bi-info" />
                </div>
            }
        </>
    );
}
